'use strict';
const createSVGDOM = require('./create-svg-dom'),
	convertPositionToTransform = require('@mindmup/mapjs-core/src/util/convert-position-to-transform'),
	updateConnectorText = require('./update-connector-text'),
	calcLabelCenterPoint = require('./calc-label-center-point'),
	checkParams = require('@mindmup/js-utils/src/check-params'),
	attr = require('../dom/attr'),
	css = require('../dom/css'),
	hide = require('../dom/hide'),
	show = require('../dom/show'),
	showArrows = function (connection, domElement) {
		const arrowElements = Array.from(domElement.querySelectorAll('path.mapjs-arrow'));
		if (connection.arrows && connection.arrows.length) {
			//connection.arrow can be true, 'to', 'from', 'both'
			connection.arrows.forEach((arrow, index) => {
				let arrowElement = arrowElements[index];
				if (!arrowElement) {
					arrowElement = createSVGDOM('path');
					arrowElement.setAttribute('class', 'mapjs-arrow');
					domElement.appendChild(arrowElement);
				}
				attr(arrowElement, {
					d: arrow,
					fill: connection.lineProps.color,
					'stroke-width': connection.lineProps.width
				});
				show(arrowElement);
			});
			arrowElements.slice(connection.arrows.length).forEach(hide);
		} else {
			arrowElements.forEach(hide);
		}
	};

module.exports = function updateLink(params) {
	checkParams(params, ['domElement', 'connection', 'stage', 'fromBox', 'toBox']);
	const {domElement, connection, stage, fromBox, toBox} = params,
		labelText = connection.label || '',
		applyLabel = function (connection, fromBox, toBox) {
			const labelTheme = connection.theme.label,
				labelCenterPoint = labelText && calcLabelCenterPoint(connection, fromBox, toBox, connection.d);
			updateConnectorText(
				stage,
				domElement,
				labelCenterPoint,
				labelText,
				labelTheme
			);
		},
		newStyle = Object.assign(convertPositionToTransform(connection.position), {stroke: connection.lineProps.color});
	let pathElement = domElement.querySelector('path.mapjs-link'),
		hitElement = domElement.querySelector('path.mapjs-link-hit');

	css(domElement, newStyle);

	if (!pathElement) {
		pathElement = createSVGDOM('path');
		pathElement.setAttribute('class', 'mapjs-link');
		domElement.appendChild(pathElement);
	}
	attr(pathElement, {
		'd': connection.d,
		'stroke-width': connection.lineProps.width || 0,
		'stroke-dasharray': connection.lineProps.strokes || '',
		'stroke-linecap': connection.lineProps.linecap || '',
		fill: 'transparent'
	});

	if (!hitElement) {
		hitElement = createSVGDOM('path');
		hitElement.setAttribute('class', 'mapjs-link-hit noTransition');
		domElement.appendChild(hitElement);
	}
	attr(hitElement, {
		'd': connection.d,
		'stroke-width': connection.lineProps.width + 12
	});
	showArrows(connection, domElement);
	applyLabel(connection, fromBox, toBox);
};

